// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .Policies-root-_BfG7 {
 	padding-left: 0px;
 	padding-right: 0px;
 }

 .Policies-container-zo3Uk {
 	margin: 0px auto;
 	padding: 0 0 40px;
 	margin-top: 30px;
 	max-width: var(--max-content-width);
 }`, "",{"version":3,"sources":["webpack://./src/routes/cancellationPolicies/Policies.css"],"names":[],"mappings":"CAAC;EACC,iBAAiB;EACjB,kBAAkB;CACnB;;CAEA;EACC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;CACpC","sourcesContent":[" .root {\n \tpadding-left: 0px;\n \tpadding-right: 0px;\n }\n\n .container {\n \tmargin: 0px auto;\n \tpadding: 0 0 40px;\n \tmargin-top: 30px;\n \tmax-width: var(--max-content-width);\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Policies-root-_BfG7`,
	"container": `Policies-container-zo3Uk`
};
module.exports = ___CSS_LOADER_EXPORT___;
